import React from "react";
import heroBg from "../assets/herobg1.png";
import exportImg1 from "../assets/exportimg1.png";
import exportImg2 from "../assets/exportimg2.png";
import Header from "../components/Header";
import { CategoriesSection, StaticFeaturesSection } from "../components/ProductCategories";

export default function AboutUs() {
  return (
    <main className="min-h-screen bg-[#FBF1EB]">
      <Header />

      {/* Hero Image */}
      <div className="relative w-full h-[350px] sm:h-[300px] overflow-hidden">
        <img
          src={heroBg}
          alt="Export Hero Image"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* About Us */}
      <section className="w-full py-16 px-4 md:px-12 lg:px-24 bg-[#FBF1EB]">
        <h1 className="text-5xl font-serif font-semibold text-center text-[#34302B] mb-12">
          About Us
        </h1>

        <div className="max-w-7xl mx-auto text-lg text-[#34302B] leading-relaxed space-y-6">
          <p>
            <strong>Synergy Innovative Enterprises</strong> is a globally trusted name in the export industry, specializing in delivering premium-quality products including <strong>Spices, Dehydrated Fried Onions, Onion Powder</strong>. With a foundation rooted in integrity and a vision to serve the global food industry, we’ve emerged as a preferred partner for clients worldwide.
          </p>
          <p>
            Our journey began with a commitment to bringing authentic Indian product to the global market, maintaining the perfect balance between tradition and technology. With modern infrastructure, dedicated R&D, and a skilled team, we ensure that every product reflects excellence—from sourcing to packaging.
          </p>
          <p>
            Today, we export to multiple continents and cater to a broad client base—from international wholesalers to food processing companies and restaurant chains—ensuring timely delivery, unmatched quality, and full transparency in every transaction.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="w-full py-16 px-4 md:px-12 lg:px-24 bg-white">
        <h2 className="text-5xl font-serif font-semibold text-center text-[#34302B] mb-12">
          Our Mission
        </h2>

        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-6 text-lg text-[#34302B] leading-relaxed">
            <p>
              Our mission is to consistently deliver high-quality, safe, and innovative food solutions that help our global clients thrive. We strive to maintain rigorous quality controls, ethical sourcing, and sustainable practices to ensure every product represents purity and excellence.
            </p>
            <p className="mt-4">
              We aim to become the go-to export partner for clients seeking trust, value, and performance in their international procurement journey.
            </p>
          </div>
          <div className="md:col-span-6">
            <img
              src={exportImg2}
              alt="Export Mission Image"
              className="rounded-2xl shadow-md object-cover w-full h-[400px]"
            />
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className="w-full py-16 px-4 md:px-12 lg:px-24 bg-[#FBF1EB]">
        <h2 className="text-5xl font-serif font-semibold text-center text-[#34302B] mb-12">
          Our Vision
        </h2>

        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-6">
            <img
              src={exportImg1}
              alt="Export Vision Image"
              className="rounded-2xl shadow-md object-cover w-full h-[350px]"
            />
          </div>
          <div className="md:col-span-6 text-lg text-[#34302B] leading-relaxed">
            <p>
              Our vision is to be a benchmark in the global export sector—recognized for reliability, innovation, and customer satisfaction. We envision a world where every buyer, no matter the geography, can access India’s finest exports with ease, trust, and value.
            </p>
            <p className="mt-4">
              Through continuous innovation, sustainable growth, and deep-rooted partnerships, we aspire to elevate the global footprint of Indian agro-products and food ingredients.
            </p>
          </div>
        </div>
      </section>
        <h3 className="text-3xl md:text-4xl font-extrabold text-[#4b2e19] text-center mt-10 drop-shadow-sm bg-white overflow-hidden">
        SHOP BY CATEGORY
      </h3>
 <CategoriesSection isHome={true} />
      {/* Why Choose Us */}
      <section className="w-full py-20 px-4 md:px-12 lg:px-24 bg-white">
        <h2 className="text-5xl font-serif font-semibold text-center text-[#34302B] mb-12">
          Why Choose Us
        </h2>

        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-[#34302B]">
          <div className="bg-[#FBF1EB] p-6 rounded-xl shadow-sm hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-3">Global Standards</h3>
            <p>We adhere to international food safety standards with strict quality control and traceability systems.</p>
          </div>
          <div className="bg-[#FBF1EB] p-6 rounded-xl shadow-sm hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-3">Customized Solutions</h3>
            <p>Whether you need bulk exports or custom packaging, we offer tailored services to meet your unique business needs.</p>
          </div>
          <div className="bg-[#FBF1EB] p-6 rounded-xl shadow-sm hover:shadow-lg transition">
            <h3 className="text-xl font-semibold mb-3">Timely Deliveries</h3>
            <p>Our logistics network ensures that your products are shipped on time, every time—anywhere across the globe.</p>
          </div>
        </div>
      </section>

    
    </main>
  );
}
